import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=89fe4eba&scoped=true&"
import script from "./ArticleCard.vue?vue&type=script&lang=js&"
export * from "./ArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=89fe4eba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fe4eba",
  null
  
)

export default component.exports